export const LEADERBOARD_TRIGGERS = {
  ON_DEMAND_WHILE_PRESENTING: 'ON_DEMAND_WHILE_PRESENTING',
  AFTER_QUIZ_RESULT_SHOWN: 'AFTER_QUIZ_RESULT_SHOWN',
}
